var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",attrs:{"role":"banner"}},[(!_vm.isEmbedded)?_c('CompanyHeader',{ref:"company-header",attrs:{"companyLogo":_vm.companyLogo,"companyName":_vm.company.name,"companyUrl":_vm.company.websiteUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }